export const DEFAULT_SCROLL_VALUE = 300;
export const DEFAULT_SCROLL_DIRECTIONS = ['left', 'right'];
export const DEADHEAD_BORDER_COLOR = '#3B873E';
export const DEFAULT_THEME_COLOR = '#2B64CB';
export const NEEDLOAD_COLOR = '#C8372C';
